<template>
  <database-layout>
    <div class="space-y-4">
      <base-input label="Destination Database" :disabled="true" v-model="currentDatabaseName" />
      <base-input label="Source Database" :disabled="true" v-model="importDatabaseName" />
      <base-button tag="inertia-link" :href="route('cms.database.sync.step', {step: steps[0].value})">Begin</base-button>
    </div>
  </database-layout>
</template>
<script>
import DatabaseLayout from '../Layout.vue'
import Form from '../../../components/Form';
export default {
components: {
  DatabaseLayout,
  ...Form,
},
props: {
  currentDatabaseName: '',
  importDatabaseName: '',
  steps: [],
}

}
</script>
